import clubPlaceholder from '#src/assets/club/shield_none.webp';

export const FRONTEND_ASSET_HOST = 'https://frontend-assets.sorare.com';
export const ASSETS_HOST = 'https://assets.sorare.com';
// Screenshots of a page, keyed by its path. `rendering.sorare.com` serves the
// SPA itself and must not be used as a social image.
export const SOCIAL_IMAGE_HOST = 'https://img.sorare.com';

export const PLAYER_PLACEHOLDER = `${FRONTEND_ASSET_HOST}/placeholders/player.png`;
export const CLUB_PLACEHOLDER = clubPlaceholder;
